export default function TeamRollupCards({ items = [] }) {
  return (
    <div className="rtv2-rollup-grid">
      {items.map((r) => (
        <div className="rtv2-rollup-cell" key={r.key}>
          <div className="k">{r.key}</div>
          <div className="v">{r.value}</div>
          <div className="m">{r.meta}</div>
        </div>
      ))}
    </div>
  );
}
